import { createVanIconComponent } from "./van"

const Bookmark = createVanIconComponent("bookmark")
export default Bookmark
